module.exports = __webpack_public_path__ + "static/media/signature-white.fa6a94bc.png";